
import DocumentFilter from "../../../assets/outline/DocumentFilter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentFilterIcon({ className, dataTestid = "DocumentFilterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentFilter data-testid={dataTestid} className={classes} {...rest} />
  );
}
